var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHouseOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123 2.21374C16.4348 2.07523 16.2161 2 15.9909 2C15.7658 2 15.5471 2.07523 15.3696 2.21374L1 13.4193L2.2427 14.991L4 13.6208V25.9999C4.00108 26.53 4.21215 27.0381 4.58698 27.413C4.96182 27.7878 5.4699 27.9989 6 27.9999H26C26.5301 27.999 27.0383 27.7879 27.4131 27.4131C27.788 27.0382 27.999 26.5301 28 25.9999V13.6299L29.7573 14.9999L31 13.4281L16.6123 2.21374ZM18 25.9999H14V17.9999H18V25.9999ZM20 25.9999V17.9999C19.9994 17.4697 19.7885 16.9613 19.4135 16.5864C19.0386 16.2115 18.5302 16.0006 18 15.9999H14C13.4697 16.0005 12.9613 16.2114 12.5864 16.5863C12.2114 16.9613 12.0005 17.4697 12 17.9999V25.9999H6V12.0614L16 4.27144L26 12.0719V25.9999H20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHouseOutlined);
export default __webpack_public_path__ + "static/media/ic-house-outlined.60de44dc5439c5f351a1711d9d30d5d4.svg";
export { ForwardRef as ReactComponent };